var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 17C18.1284 17 18.0716 16.977 18.0299 16.9362L10.1577 9.23382C10.0707 9.14871 9.92931 9.14871 9.84232 9.23382L1.97012 16.9362C1.92835 16.977 1.87161 17 1.81244 17L0.223033 17C0.0249227 17 -0.0744754 16.7667 0.0653563 16.6298L9.84232 7.06384C9.92931 6.97872 10.0707 6.97872 10.1577 7.06384L19.9346 16.6298C20.0745 16.7667 19.9751 17 19.777 17L18.1876 17Z",
    fill: "#FFE500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 12C18.1284 12 18.0716 11.977 18.0299 11.9362L10.1577 4.23382C10.0707 4.14871 9.92931 4.14871 9.84232 4.23382L1.97012 11.9362C1.92835 11.977 1.87161 12 1.81244 12L0.223033 12C0.0249227 12 -0.0744754 11.7667 0.0653563 11.6298L9.84232 2.06384C9.92931 1.97872 10.0707 1.97872 10.1577 2.06384L19.9346 11.6298C20.0745 11.7667 19.9751 12 19.777 12L18.1876 12Z",
    fill: "#FFE500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleUp);
export default __webpack_public_path__ + "static/media/arrow-double-up.a44e4d4be85549d688c830e1f714b366.svg";
export { ForwardRef as ReactComponent };